// Copyright ©️ 2026 eVolve MEP, LLC

import { Button, Text, Title } from '@mantine/core';
import { Navigate } from 'react-router';

import { URL_REFRESH_KEY } from 'components/Mantine/Navigation/useAppNeedsRefresh';
import { useEvolveNavigate } from 'components/Mantine/Navigation/useEvolveNavigate';

import { FullPageError } from './FullPageError';

export const PageNotFound = () => {
  const navigate = useEvolveNavigate('', true);
  const goBack = () => navigate(-1);
  const goToHelpCenter = () => (window.location.href = 'https://evolvemep.com/contact-support');

  // It's possible that a race condition causes the etag to be improperly appended as
  // &etag= instead of ?etag= - if that causes us to hit a 404, just replace it.
  if (window.location.pathname.includes(`&${URL_REFRESH_KEY}`)) {
    return <Navigate to={window.location.pathname.replace(`&${URL_REFRESH_KEY}`, `?${URL_REFRESH_KEY}`)} replace />;
  }

  return (
    <FullPageError>
      <Title fz={100}>404</Title>
      <Text ta="center" maw={480}>
        {"Uh oh, we can't seem to find the page you're looking for. Try going back to the previous page, or "}
        <Text c="indigo.3" onClick={goToHelpCenter} style={{ cursor: 'pointer' }} span>
          contact support.
        </Text>
      </Text>
      <Button mt="xs" variant="filled" onClick={goBack} color="light">
        Go back
      </Button>
    </FullPageError>
  );
};
